import React from 'react';
import { Position } from '../../services/reportApi';

interface PositionsTableProps {
    positions: Position[];
}

const PositionsTable: React.FC<PositionsTableProps> = ({ positions }) => {
    const formatCurrency = (value: number) => {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
        }).format(value);
    };

    const formatPercent = (value: number) => {
        const sign = value >= 0 ? '+' : '';
        return `${sign}${value.toFixed(2)}%`;
    };

    return (
        <section className="section">
            <h2>보유 포지션 ({positions.length}개)</h2>
            {positions.length === 0 ? (
                <div className="empty">포지션이 없습니다.</div>
            ) : (
                <div className="positions-table">
                    <table>
                        <thead>
                            <tr>
                                <th>종목</th>
                                <th>유형</th>
                                <th>수량</th>
                                <th>평가액</th>
                                <th>수익률</th>
                                <th>평가손익</th>
                            </tr>
                        </thead>
                        <tbody>
                            {positions.map((pos, index) => (
                                <tr key={index}>
                                    <td className="symbol">{pos.symbol}</td>
                                    <td>
                                        <span className={`asset-badge ${pos.asset_type}`}>
                                            {pos.asset_type === 'stock' ? '주식' : '암호화폐'}
                                        </span>
                                    </td>
                                    <td>{pos.qty.toFixed(2)}</td>
                                    <td>{formatCurrency(pos.market_value)}</td>
                                    <td className={pos.unrealized_pl_percent >= 0 ? 'positive' : 'negative'}>
                                        {formatPercent(pos.unrealized_pl_percent)}
                                    </td>
                                    <td className={pos.unrealized_pl >= 0 ? 'positive' : 'negative'}>
                                        {formatCurrency(pos.unrealized_pl)}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </section>
    );
};

export default PositionsTable;
